import { render, staticRenderFns } from "./SetRemote.vue?vue&type=template&id=94732734&scoped=true"
import script from "./SetRemote.vue?vue&type=script&lang=js"
export * from "./SetRemote.vue?vue&type=script&lang=js"
import style0 from "./SetRemote.vue?vue&type=style&index=0&id=94732734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94732734",
  null
  
)

export default component.exports